
import {Component, Prop, Vue} from "vue-property-decorator";

/**
 * Rapor çıktısının üstündeki özet (KPI) kartı.
 * `renk` yalnız vurgu içindir; anlam başlık metninde durur — renk tek başına
 * bilgi taşımaz (renk körlüğü / yazdırma).
 */
@Component({})
export default class RaporOzetKarti extends Vue {
  @Prop({required: true}) baslik!: string;
  @Prop({required: true}) deger!: string;
  /** "olumlu" (tahsilat) · "olumsuz" (kalan bakiye) · "" (nötr) */
  @Prop({default: ""}) renk!: string;
  /** true: gradyan dolu kart (tek bir kart için) */
  @Prop({default: false}) vurgulu!: boolean;

  get renkSinifi(): string {
    if (this.vurgulu) return "";
    if (this.renk === "olumlu") return "roz-deger--olumlu";
    if (this.renk === "olumsuz") return "roz-deger--olumsuz";
    return "";
  }
}
